"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewPlatformSortCode = exports.REVIEW_PLATFORM_SORT_OPTION = exports.GLOBAL_SORT_OPTION = exports.DOMESTIC_SORT_OPTION = void 0;
var zod_1 = require("zod");
exports.DOMESTIC_SORT_OPTION = {
    'recommend:asc': {
        code: 'recommend:asc',
    },
    'best:desc': {
        code: 'best:desc',
    },
    'created-at:desc': {
        code: 'created-at:desc',
    },
    'score:desc': {
        code: 'score:desc',
    },
    'score:asc': {
        code: 'score:asc',
    },
};
/**
 * 해외숙소 정렬 옵션
 * @see https://yanolja.atlassian.net/wiki/spaces/yanoljareview/pages/75089316
 * */
exports.GLOBAL_SORT_OPTION = {
    LANGUAGE_DESC: {
        code: 'LANGUAGE_DESC',
    },
    REVIEWED_AT_DESC: {
        code: 'REVIEWED_AT_DESC',
    },
    SCORE_DESC: {
        code: 'SCORE_DESC',
    },
    SCORE_ASC: {
        code: 'SCORE_ASC',
    },
};
/**
 * @see https://yanolja.atlassian.net/wiki/spaces/yanoljareview/pages/233440456/API+-+07.#Request-Parameter
 * sort: 정렬 옵션
 * 국내숙소, 레저 리뷰에 대한 정렬 옵션은 해당 상수를 이용
 * 해외숙소는 별개
 * */
exports.REVIEW_PLATFORM_SORT_OPTION = {
    /** RECOMMEND: 추천순 (추천순 후기 10건 이상인 경우만 제공) */
    RECOMMEND: {
        code: 'RECOMMEND',
    },
    /** HOST_CHOICE: 최신순 (업주 선정 후기 상단 고정) */
    HOST_CHOICE: {
        code: 'HOST_CHOICE',
    },
    /**
     *  LATEST: 최신순
     *  @deprecated HOST_CHOICE 로 통일
     *  */
    LATEST: {
        code: 'LATEST',
    },
    /** HIGH_RATING: 별점 높은순 */
    HIGH_RATING: {
        code: 'HIGH_RATING',
    },
    /** LOW_RATING: 별점 낮은순 */
    LOW_RATING: {
        code: 'LOW_RATING',
    },
};
exports.ReviewPlatformSortCode = zod_1.z.union([
    zod_1.z.literal(exports.REVIEW_PLATFORM_SORT_OPTION.RECOMMEND.code),
    zod_1.z.literal(exports.REVIEW_PLATFORM_SORT_OPTION.HOST_CHOICE.code),
    zod_1.z.literal(exports.REVIEW_PLATFORM_SORT_OPTION.LATEST.code),
    zod_1.z.literal(exports.REVIEW_PLATFORM_SORT_OPTION.HIGH_RATING.code),
    zod_1.z.literal(exports.REVIEW_PLATFORM_SORT_OPTION.LOW_RATING.code),
]);
